module.exports = {"371422001":"宁城街道","371422002":"津城街道","371422101":"柴胡店镇","371422102":"长官镇","371422103":"杜集镇","371422104":"保店镇","371422105":"大柳镇","371422106":"大曹镇","371422107":"相衙镇","371422108":"时集镇","371422109":"张大庄镇","371422201":"刘营伍乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371422.json
// module id = 1355
// module chunks = 0